const RESPONSIVE_BREAKPOINTS = {
  md: 768,
  lg: 992,
  xl: 1200
};
const RESPONSIVE_BREAKPOINTS_PX = {
  md: `${RESPONSIVE_BREAKPOINTS.md}px`,
  lg: `${RESPONSIVE_BREAKPOINTS.lg}px`,
  xl: `${RESPONSIVE_BREAKPOINTS.xl}px`
};
const RESPONSIVE_MEDIA_QUERIES = {
  /**
   *  Note: in the future this media query may be updated to include a min-height
   */
  md: `@media screen and (max-width: ${RESPONSIVE_BREAKPOINTS_PX.md})`,
  lg: `@media screen and (max-width: ${RESPONSIVE_BREAKPOINTS_PX.lg})`,
  xl: `@media screen and (max-width: ${RESPONSIVE_BREAKPOINTS_PX.xl})`
};
const RESPONSIVE_VERTICAL_BREAKPOINTS = {
  lg: 680
};
const RESPONSIVE_VERTICAL_BREAKPOINTS_PX = {
  lg: `${RESPONSIVE_VERTICAL_BREAKPOINTS.lg}px`
};
const RESPONSIVE_VERTICAL_MEDIA_QUERIES = {
  lg: `@media screen and (max-height: ${RESPONSIVE_VERTICAL_BREAKPOINTS_PX.lg})`
};
export {
  RESPONSIVE_BREAKPOINTS,
  RESPONSIVE_BREAKPOINTS_PX,
  RESPONSIVE_MEDIA_QUERIES,
  RESPONSIVE_VERTICAL_BREAKPOINTS,
  RESPONSIVE_VERTICAL_BREAKPOINTS_PX,
  RESPONSIVE_VERTICAL_MEDIA_QUERIES
};
//# sourceMappingURL=style.constants.js.map
